export function enhanceAvaMaterials(scene, iosSafeMode = false) {
    scene.traverse((obj) => {
        if (!obj?.isMesh || !obj.material)
            return;
        const mats = Array.isArray(obj.material)
            ? obj.material
            : [obj.material];
        mats.forEach((m) => {
            if (!m)
                return;
            const n = String(m.name || "").toLowerCase();
            //--------------------------------
            // Carbon / Armor
            //--------------------------------
            if (n.includes("carbon") ||
                n.includes("fiber") ||
                n.includes("armor") ||
                n.includes("shell")) {
                m.metalness = 0.32;
                m.roughness = 0.76;
                if ("envMapIntensity" in m)
                    m.envMapIntensity = 0.08;
            }
            //--------------------------------
            // Ceramic
            //--------------------------------
            if (n.includes("white") ||
                n.includes("panel")) {
                m.metalness = 0.05;
                m.roughness = 0.83;
            }
            //--------------------------------
            // Gunmetal
            //--------------------------------
            if (n.includes("metal") ||
                n.includes("gun")) {
                m.metalness = 0.42;
                m.roughness = 0.64;
            }
            if (!iosSafeMode) {
                // =====================================================
                // AVA_VISUAL_DETAIL_ENGINE
                // =====================================================
                const meshName = String(obj.name || "").toLowerCase();
                //------------------------------------
                // Carbon Fiber
                //------------------------------------
                if (meshName.includes("carbon") ||
                    meshName.includes("fiber") ||
                    meshName.includes("shell") ||
                    n.includes("carbon") ||
                    n.includes("fiber")) {
                    m.metalness = 0.38;
                    m.roughness = 0.72;
                    if ("envMapIntensity" in m) {
                        m.envMapIntensity = 0.10;
                    }
                }
                //------------------------------------
                // Circuit Boards
                //------------------------------------
                if (n.includes("circuit") ||
                    n.includes("board") ||
                    n.includes("trace")) {
                    if (m.emissiveIntensity !== undefined)
                        m.emissiveIntensity *= 1.15;
                    m.roughness *= 0.85;
                }
                //------------------------------------
                // Ceramic Panels
                //------------------------------------
                if (n.includes("white") ||
                    n.includes("panel")) {
                    m.roughness = 0.84;
                    m.metalness = 0.05;
                }
                //------------------------------------
                // Gunmetal
                //------------------------------------
                if (n.includes("gun") ||
                    n.includes("metal")) {
                    m.metalness = 0.45;
                    m.roughness = 0.60;
                }
                //------------------------------------
                // Horn Materials
                //------------------------------------
                if (n.includes("horn")) {
                    if (m.emissiveIntensity !== undefined)
                        m.emissiveIntensity *= 1.18;
                    m.roughness = 0.22;
                }
                m.needsUpdate = true;
            }
        });
    });
}
